import comum from "../helpers/comum";

const CODIGO_INICIAL = `# Obrigatoriamente a classe deve extender de Function e implementar o run().
class NovaFuncao(Function):
    def run(self):
        pass`;

const NEW_FUNCTION = {
  name: "Nova Função",
  data: {
    title: "Nova Função",
    type: {
      icon: "https://img.freepik.com/free-vector/illustration-cogwheel_53876-6326.jpg",
      title: "Nova Função",
      type: comum.GenerateId(20),
    },
  },
  code: CODIGO_INICIAL,
  params: [],
  type: "custom",
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  position: {
    x: 0,
    y: 0,
  },
  targetPosition: "left",
  sourcePosition: "right",
};

const TIPOS_DE_CAMPOS_PARAMETROS = [
  {
    value: "select",
    label: "Resultado de outra função (select)",
  },
  {
    value: "text",
    label: "Texto",
  },
  {
    value: "textbox",
    label: "Textos Grandes (TextArea)",
  },
  {
    value: "number",
    label: "Numérico",
  },
  {
    value: "arquivo",
    label: "Arquivo",
  },
  {
    value: "function-search",
    label: "Buscar Dinamicamente na Função (select)",
  },
  {
    value: "dynamic-simples",
    label: "Dinâmica Simples",
  },
  {
    value: "dynamic",
    label: "Dinâmica Webhook",
  },
  {
    value: "code",
    label: "Código Python",
  },
  {
    value: "condicional",
    label: "Condicional",
  },
];

export default { NEW_FUNCTION, TIPOS_DE_CAMPOS_PARAMETROS };
